
<div class="grid grid-cols-12 authentication mx-0 text-defaulttextcolor text-defaultsize">
  <div class="xxl:col-span-5 xl:col-span-5 lg:col-span-5 col-span-12 xl:block hidden px-0">
    <div class="authentication-cover">
      <img src="./assets/img/desktop-white.png" alt="Logo SOAR" class="w-1/3 mx-auto mb-8" />
      <h5 class="text-white">{{ 'welcome' | translate | capitalize }}</h5>
    </div>
  </div>
  <div class="xxl:col-span-7 xl:col-span-7 lg:col-span-12 col-span-12">
    <div class="authentication-form">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>